var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTatvaAiActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4061 18.8748C15.972 18.8748 10.8937 21.0373 9.03383 22.1185C7.53771 22.86 6.95492 21.8096 6.85053 21.1918C6.85053 16.0018 4.58628 11.1517 3.45416 9.37536C2.87193 8.26322 3.69675 7.5218 4.18194 7.29011C10.7805 6.9194 15.1796 4.81871 16.5543 3.81471C18.3009 3.25864 18.8993 4.35533 18.9802 4.97318C19.1743 9.97777 21.487 15.0905 22.6191 17.0213C23.2013 18.3188 22.0531 18.7976 21.4061 18.8748Z",
    stroke: "#4B4AD5",
    strokeWidth: 1.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1382 22.7384C10.6643 18.9797 5.85176 16.9144 3.87972 16.3516C2.38632 15.813 2.77448 14.7069 3.15523 14.2211C6.91402 10.7473 8.97923 5.93469 9.54199 3.96263C9.97525 2.8155 11.0395 2.88977 11.5175 3.07029C16.0042 7.3864 20.3378 9.02315 21.9437 9.30202C23.463 10.138 23.0513 11.286 22.6555 11.7555C19.155 15.2395 16.9306 20.2614 16.256 22.3368C15.6885 23.608 14.6077 23.1342 14.1382 22.7384Z",
    stroke: "#4B4AD5",
    strokeWidth: 1.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTatvaAiActiveIcon);
export default __webpack_public_path__ + "static/media/tatvaAiActiveIcon.938b61f0d790cba0713ff417be3abf79.svg";
export { ForwardRef as ReactComponent };